import React from "react";

const OrderEvents = () => {
  return <div>Events</div>;
};

export default OrderEvents;
